import React from 'react';

const options = [];
const OptionsContext = React.createContext(options);
export const OptionsProvider = OptionsContext.Provider;
export const OptionsConsumer = OptionsContext.Consumer;

export default OptionsContext;
